// NewObjectPage.jsx
import React, { useEffect, useState } from 'react';
import {
  Button,
  Container,
  useTheme,
  useMediaQuery,
  Box,
  Typography,
  Snackbar,
  Alert,
  Grid,
} from '@mui/material';
import { FaLongArrowAltRight } from 'react-icons/fa';
import objectStore from '../stores/objectStore';
import { observer } from 'mobx-react-lite';
import helperStore from '../stores/helperStore';

import SaleTypeSelector from '../components/SaleTypeSelector';
import CategorySelector from '../components/CategorySelector';
import DynamicFields from '../components/DynamicFields';
import FileUpload from '../components/FileUpload';
import statusStore from '../stores/statusStore';
import TagSelector from '../components/settings/tags/TagSelector';
import { useNavigate } from 'react-router-dom';
import logger from '../utils/logger';
import i18nStore from '../stores/i18nStore';
import apiClient from '../utils/apiClient';
import CustomFieldInputs, { rawChange } from '../components/customFields/CustomFieldInputs';

const NewObjectPage = observer(() => {
  //const [categories, setCategories] = useState([]) // json с категориями и подкатегориями
  const { categories, catalogStatus, catalogCountry, catalogError } = objectStore;
  const country = i18nStore.currentCountry;
  const navigate = useNavigate();
  const [selectedTags, setSelectedTags] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [saleType, setSaleType] = React.useState('sale');
  const [categoryId, setCategoryId] = React.useState(0);
  const [categoryName, setCategoryName] = React.useState('');

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [formCounter, setFormCounter] = useState(1);
  const [fileName, setFileName] = useState('');
  const [fields, setFields] = useState([]);

  const [fieldsFromDynamicFields, setFieldsFromDynamicFields] = useState([]);

  const [filesFromFileUpload, setFilesFromFileUpload] = useState([]);

  const [jsonFileName, setJsonFileName] = useState([]);

  const [errorMessage, setErrorMessage] = useState('');
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [customFieldValues, setCustomFieldValues] = useState({});

  // Загружаем теги, если их ещё нет в сторе
  useEffect(() => {
    if (statusStore.tags.length === 0) {
      statusStore.fetchTags('NewObjectPage.jsx');
    }
  }, []);

  useEffect(() => {
    objectStore.fetchCategoriesAndFiles(country);
  }, [country]);

  // useEffect для вызова fetchLastNewObject при размонтировании
  useEffect(() => {
    // Возвращаем функцию очистки, которая будет вызвана при размонтировании компонента
    return () => {
      logger.log('Компонент NewObjectPage размонтируется, вызываем fetchLastNewObject');
      objectStore.fetchLastNewObject();
    };
  }, []); // Пустой массив зависимостей означает, что эффект выполнится один раз при монтировании и функция очистки при размонтировании

  if (catalogCountry !== country || catalogStatus === 'idle' || catalogStatus === 'loading') {
    return <p>Загрузка…</p>;
  }
  if (catalogStatus === 'error') {
    return <Alert severity="error" action={<Button onClick={() => objectStore.fetchCategoriesAndFiles(country)}>Повторить</Button>}>
      {catalogError}
    </Alert>;
  }
  if (categories.length === 0) {
    return <p>Нет доступных категорий.</p>;
  }

  /* тут надо делать запрос в mobx, вытащить информацию по fileName и установить его в setFileds */

  const getSubcategory = async (fileName) => {
    /* const locale = 'RU'; // Здесь можно динамически задавать язык */
    logger.log('🎗  fileName:', fileName);
    setJsonFileName(fileName);

    logger.log('🚜🚜🚜🚜🚜🚜🚜');

    /* logger.log('jsonfiles:', JSON.stringify(objectStore.jsonfiles)); */
    logger.log('fileName:', JSON.stringify(fileName));
    logger.log('🏀 jsonFileName:', JSON.stringify(jsonFileName));

    try {
      // Ищем данные в MobX store
      const subcategoryData = objectStore.jsonfiles.find(
        (field) => field.type && field.type.fileName === fileName,
      );

      if (!subcategoryData) {
        throw new Error(`Данные с fileName "${fileName}" не найдены в store`);
      }

      logger.log('Найденные данные:', subcategoryData);

      // Устанавливаем данные в состояние
      setFields(subcategoryData);

      // Проверяем наличие объектов в objectStore
      if (objectStore.objects.length === 0) {
        // Если объектов нет, загружаем их из filterStore
        import('../stores/filterStore').then(({ default: filterStore }) => {
          logger.log('Объекты не найдены, вызываем fetchFOfromObjectPage');
          filterStore.fetchFOfromObjectPage();
        });
      }
    } catch (error) {
      logger.error('Ошибка при загрузке полей:', error);
    }
  };

  function saleTypeHandler(saleType) {
    setSaleType(saleType);
  }

  function categoryHandler(categoryId, categoryName, fields) {
    setCategoryId(categoryId);
    setCategoryName(categoryName);
    setFields(fields);

    // Сразу вызываем переход к следующему шагу при выборе категории
    if (categoryId !== 0 && categoryName !== '') {
      setFormCounter(2);
      getSubcategory(fields);
    }
  }

  function handlerContinueClick() {
    logger.log('saleType:', saleType, ' categoryId:', categoryId, ' categoryName:', categoryName);

    if (saleType === '' || categoryId === 0 || categoryName === '') {
      alert('Выберите категорию');
      return;
    }

    setFormCounter(2);
    logger.log('🎏  fields:', fields);

    getSubcategory(fields);
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
    setErrorSnackbarOpen(false);
  };

  const postNewObject = async () => {
    logger.log(' postNewObject');

    // Проверяем обязательные поля
    if (fieldsFromDynamicFields.validateDynamicFields) {
      const isFormValid = fieldsFromDynamicFields.validateDynamicFields();
      if (!isFormValid) {
        // Алерт не нужен, так как есть визуальные индикаторы ошибок
        // alert('Пожалуйста, заполните все обязательные поля');
        return;
      }
    }

    // Получаем данные адреса
    const addressData = fieldsFromDynamicFields.addressData;
    /* logger.log('Address Data:', addressData); */

    const subcategoryId = categoryId;

    // A tag is identified by its organization-scoped id only.
    const simplifiedTags = selectedTags.map((tag) => ({
      id: tag.id,
    }));

   /*  logger.log('🔍 Отправка на сервер colleaguesToSend:', colleaguesToSend); */

    const countryCodeISO = i18nStore.currentCountry;

    // Проверяем, если _mainDealType равен 2 и отсутствует _rent_type, то добавляем его
    const updatedFields = { ...fieldsFromDynamicFields };
    if (updatedFields._mainDealType === 2 && updatedFields._rent_type === undefined) {
      updatedFields._rent_type = 1;
      logger.log('Автоматически добавлено поле _rent_type = 1 для аренды');
    }

    /* logger.log('🏡 updatedFields', JSON.stringify(updatedFields)); */

    const result = await objectStore.addNewObject(
      {
        ...updatedFields,
        addressData, // добавляем структурированные данные
        tags: simplifiedTags, // Отправляем упрощенный формат тегов
        jsonFileName,
        // НЕ нужно добавлять colleagues здесь, так как он передается отдельным параметром
      },
      countryCodeISO,
      subcategoryId,
    );

    // Проверяем результат операции
    if (result && result.success) {
		const objectId = result.data?.object?.id || objectStore.idNewObject;
		const changes = Object.entries(customFieldValues)
			.map(([definitionId, value]) => rawChange({ id: definitionId, ...value.definition }, value.raw, value.clear))
			.filter(change => change.clear !== true);
		if (objectId && changes.length) {
			try { await apiClient.patch(`/api/objects/${objectId}/custom-fields`, { changes }); }
			catch (error) { setErrorMessage(error?.response?.data?.error?.code || 'CUSTOM_FIELD_SAVE_FAILED'); setErrorSnackbarOpen(true); }
		}
      setFormCounter(3);
      setSnackbarOpen(true); // Показать уведомление о сохранении объекта
    } else if (result) {
      // Показываем сообщение об ошибке
      setErrorMessage(result.error);
      setErrorSnackbarOpen(true);
    }
  };

  const handleCancel = () => {
    // Навигация на страницу объектов при отмене
    navigate('/objects');
  };

  const postPhotoNewObject = async () => {
    const photos = helperStore.getFilesMbx();
    logger.log(`photos: ${photos}`);
    navigate('/objects');
  };

  return (
    <Container className="mt-5 ">
      {import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && (
        <div onClick={() => logger.log('NewObjectPage Render')}>% NewObjectPage %</div>
      )}

      {formCounter === 1 ||
        (formCounter === 2 && (
          <h1 className="text-left text-2xl font-semibold mb-5">Новый объект - {categoryName}</h1>
        ))}
      {formCounter === 3 && (
        <>
          <h2 className="text-xl">Объект сохранен</h2>
          <p className=" mt-5">Добавьте фотографии</p>
          <p className="text-sm">
            На фотографиях не должны присутствовать люди, животные, алкоголь, табачные изделия или
            оружие.
          </p>
        </>
      )}

      {/* Первая форма: formCounter === 0 */}
      {formCounter === 1 && (
        <>
          <CategorySelector
            categoryHandler={categoryHandler}
            categories={categories} // Передаем массив категорий из состояния mobx
          ></CategorySelector>

          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
            <Grid
              container
              spacing={1}
              sx={{ justifyContent: isMobile ? 'center' : 'space-between' }}>
              {isMobile ? (
                <>
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    onClick={handleCancel}
                    sx={{ textTransform: 'none', mt: 5 }}>
                    Отмена
                  </Button>
                </>
              ) : (
                <>
                  <div>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handleCancel}
                      sx={{ textTransform: 'none', ml: 1, mt: 5 }}>
                      Отмена
                    </Button>
                  </div>
                </>
              )}
            </Grid>
          </Box>
        </>
      )}
      {formCounter === 2 && (
        <>
          <DynamicFields
            fields={fields}
            setFieldsFromDynamicFilelds={setFieldsFromDynamicFields}
            saleType={saleType}
            jsonFileNameInput={jsonFileName}
          />

          <Box mb={4}>
            <div className="flex flex-row">
              <div>
                <Typography variant="body1" mb={1}>
                  теги:
                </Typography>
              </div>
              <div className="ml-5">
                <TagSelector selectedTags={selectedTags} onChange={setSelectedTags} />
              </div>
            </div>
          </Box>

		  <CustomFieldInputs
			values={Object.fromEntries(Object.entries(customFieldValues).map(([id, value]) => [id, value.raw]))}
			onChange={(definition, raw, clear) => setCustomFieldValues(current => ({ ...current, [definition.id]: { definition, raw, clear } }))}
		  />

          <Box sx={{ mt: 2, mb: 15, display: 'flex', justifyContent: 'space-between' }}>
            <Grid
              container
              spacing={1}
              sx={{ justifyContent: isMobile ? 'center' : 'space-between' }}>
              {isMobile ? (
                <>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={postNewObject}
                      sx={{ textTransform: 'none', mb: 1 }}>
                      Сохранить объект
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="outlined"
                      color="primary"
                      fullWidth
                      onClick={handleCancel}
                      sx={{ textTransform: 'none' }}>
                      Отмена
                    </Button>
                  </Grid>
                </>
              ) : (
                <>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 1 }}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handleCancel}
                      sx={{ textTransform: 'none' }}>
                      Отмена
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={postNewObject}
                      sx={{ textTransform: 'none' }}>
                      Сохранить объект
                    </Button>
                  </Box>
                </>
              )}
            </Grid>
          </Box>
        </>
      )}
      {formCounter === 3 && (
        <>
          {Object.entries(fields).map(([key, field]) => {
            return (
              <>
                {field.controlType === 'photo' && (
                  <FileUpload title={field} idNewObject={objectStore.idNewObject} />
                )}
              </>
            );
          })}

          {isMobile && <div style={{ height: '100px' }}></div>}

          {isMobile ? (
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={postPhotoNewObject}
              sx={{
                borderRadius: 0,
                height: '48px',
              }}>
              Закрыть
            </Button>
          ) : (
            <Box sx={{ mt: 5, display: 'flex', justifyContent: 'flex-start' }}>
              <Button variant="contained" color="primary" onClick={postPhotoNewObject}>
                Закрыть
              </Button>
            </Box>
          )}
        </>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
          Объект сохранен
        </Alert>
      </Snackbar>

      <Snackbar
        open={errorSnackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={handleSnackbarClose} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
});

export default NewObjectPage;
